import type { Project } from "@mux/sdk/v2/client"
import type { ServerConnection } from "@/context/server"
import { jsonNumber, jsonObject, jsonString } from "@/transport/decode"
import { expectJson } from "@/transport/http"
import { serverFetch } from "@/transport/server"

export function decodeWorkspace(value: unknown, invalid = "Server returned an invalid workspace"): Project {
  const workspace = jsonObject(value, invalid)
  const time = jsonObject(workspace.time, invalid)
  return {
    id: jsonString(workspace.id, invalid),
    name: jsonString(workspace.name, invalid),
    directory: jsonString(workspace.directory, invalid),
    worktree: jsonString(workspace.worktree, invalid),
    time: { created: jsonNumber(time.created, invalid), updated: jsonNumber(time.updated, invalid) },
    sandboxes: [],
  }
}

/** Renames a workspace and/or points it at another folder on the machine. */
export async function updateWorkspace(
  server: ServerConnection.HttpBase,
  workspaceID: string,
  patch: { name?: string; directory?: string },
) {
  return expectJson(
    await serverFetch(server, `/project/${encodeURIComponent(workspaceID)}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(patch),
    }),
    (value) => decodeWorkspace(value),
    { error: "Workspace update failed" },
  )
}
